import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import * as onboardingEffects from './onboarding.effects';

@NgModule({
  imports: [EffectsModule.forFeature([onboardingEffects])],
})
export class OnboardingStateModule {}
